import React from "react";
import { FiEdit } from "react-icons/fi";
import { IoDocumentLockOutline } from "react-icons/io5";
import { RiFileInfoLine } from "react-icons/ri";
import { FaRegEye } from "react-icons/fa";
import { formatINR, formatINRShort } from "../../../../utils/formatINR";

const VillaUnitTable = ({ units = [], onEdit, onAdd, totalUnitRow = 0 }) => {
  console.log("VillaUnitTable", units);

  const tableRows = Array.from({ length: totalUnitRow }, (_, index) => {
    const unit = units[index] || null;
    return {
      id: unit?.id || `placeholder-${index}`,
      unitNo: unit?.unitNo || "N/A",
      carpetArea: unit?.carpetArea || "N/A",
      buildUpArea: unit?.buildUpArea || "N/A",
      floors: unit?.floors || "N/A",
      baseRate: unit?.baseRate || "N/A",
      saleableArea: unit?.saleableArea || "N/A",
      allInclusiveCharges: unit?.allInclusiveCharges || "N/A",
      basePrice: unit?.basePrice || "N/A",
      notes: unit?.notes || "N/A",
      totalBhk: unit?.totalBhk || "N/A",

      lift: unit?.lift || "",
      bathrooms: unit?.bathrooms || "",
      villaViewType: unit?.villaViewType || "",
      coveredParking: unit?.coveredParking || "",
      swimmingPool: unit?.swimmingPool || "",
      parking: unit?.parking || "",
     
      furnished: unit?.furnished || "N/A",
      furnishedCharge : unit?.furnishedCharge || "N/A",
      electricityCharge : unit?.electricityCharge || "N/A",
      preferredLocationCharge : unit?.preferredLocationCharge || "N/A",
      roadFacingSide: unit?.roadFacingSide || { id: "", name: "N/A" },
      terraceArea: unit?.terraceArea || "N/A",

      guidelineSqftPrice: unit?.guidelineSqftPrice || "N/A",
      registrationCharge: unit?.registrationCharge || "N/A",
      totalPrice: unit?.totalPrice || "N/A",
      roadFacingSide: unit?.roadFacingSide || { id: "", name: "N/A" },
      unitStatus: unit?.unitStatus || { id: "", name: "N/A" },
      order: unit?.order || index + 1,
      isPlaceholder: !unit || unit.isArchived,
      statusName : unit?.unitStatus?.name || "N/A",
    };
  });

  const getStatusStyles = (status) => {
    switch (status) {
      case "Available":
        return "border-[#399E79] border bg-green-50 text-green-800";
      case "Agreement":
        return "border-[#FFDF94] border bg-yellow-50 text-yellow-800";
      case "Booked":
        return "border-[#EE6C4D] border bg-red-50 text-red-800";
      default:
        return "border-[#2280FF] border bg-blue-50 text-blue-800";
    }
  };

  return (
    <div className="bg-white rounded-lg p-6 shadow-sm">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="bg-gray-100 text-base text-center rounded-md">
              <th className="px-4 py-3 text-gray-700 font-medium">Unit No.</th>
              <th className="px-4 py-3 text-gray-700 font-medium">
                Saleable Area
              </th>
              <th className="px-4 py-3 text-gray-700 font-medium">
                Build-Up Area
              </th>
              <th className="px-4 py-3 text-gray-700 font-medium">Floors</th>
              <th className="px-4 py-3 text-gray-700 font-medium">BHK</th>

              <th className="px-4 py-3 text-gray-700 font-medium">Base Rate</th>
              <th className="px-4 py-3 text-gray-700 font-medium">
                Base Price
              </th>
              <th className="px-4 py-3 text-gray-700 font-medium">Status</th>
              <th className="px-4 py-3 text-gray-700 font-medium">Action</th>
            </tr>
          </thead>
          <tbody>
            {tableRows.length > 0 ? (
              tableRows.map((row) => (
                <tr
                  key={row.id}
                  className="border-b text-center border-gray-200 hover:bg-gray-50"
                >
                  <td className="px-4 text-sm py-4">{row.unitNo}</td>
                  <td className="px-4 py-4 text-sm">{row.saleableArea}</td>
                  <td className="px-4 py-4 text-sm">{row.buildUpArea}</td>

                  <td className="px-4 py-4 text-sm">{row.floors}</td>
                  <td className="px-4 py-4 text-sm">{row.totalBhk}</td>
                  <td className="px-4 py-4 text-sm cursor-pointer" title={formatINR(row.baseRate)}>{formatINRShort(row.baseRate)}</td>

                  <td title={formatINR(row?.saleableArea * row?.baseRate || row.basePrice)} className="px-4 py-4 text-sm font-medium cursor-pointer">
                    {formatINRShort(row?.saleableArea * row?.baseRate || row.basePrice)}
                  </td>

                  <td className="px-4 py-4">
                    <span
                      className={`px-3 py-1 text-xs rounded-full ${getStatusStyles(
                        row.unitStatus.name
                      )}`}
                    >
                      {row.unitStatus?.name}
                    </span>
                  </td>
                  {row.unitStatus?.name === "Available" ||
                  row?.unitStatus?.name === "N/A" ? (
                    <td className="px-4 py-4">
                      {row.isPlaceholder ? (
                        <button
                          onClick={() =>
                            onAdd({
                              order: row.order,
                              unitNo: "",
                              carpetArea: null,
                              buildUpArea: null,
                              terraceArea: null,
                              guidelineSqftPrice: null,
                              floors: 0,
                              totalBhk: 0,
                              bathrooms: 0,
                              roadFacingSide: "",

                              furnished: "",
                              parking: "",
                              coveredParking: "",
                              lift: "",
                              allInclusiveCharges: 0,
                              swimmingPool: "",
                              villaViewType: "",
                              unitStatusId: "",
                            })
                          }
                          className="p-1 px-2 bg-customGreen text-white rounded-md transition-colors flex items-center justify-center"
                          aria-label="Add unit"
                        >
                          <span className="text-sm">Add</span>
                        </button>
                      ) : (
                        <button
                          onClick={() => onEdit(row)}
                          className="p-2 text-customGreen hover:bg-blue-50 rounded-md transition-colors"
                          aria-label="Edit unit"
                        >
                          <FiEdit size={20} />
                        </button>
                      )}
                    </td>
                  ) : (
                    <td  onClick={() => onEdit(row)} className="text-center hover:text-customGreen flex items-center justify-center   text-2xl mt-4 cursor-pointer">
                      <FaRegEye />
                    </td>
                  )}
                </tr>
              ))
            ) : (
              <tr className="text-center ">
                <td colSpan={10} className="py-8 text-gray-500">
                  No units found
                </td>
              </tr>
            )}
          </tbody>
          <tfoot>
            {onAdd && (
              <tr>
                <td colSpan={10} className="px-4 py-4 text-center">
                  <button
                    onClick={() =>
                      onAdd({
                        order: tableRows.length + 1,
                        unitNo: "",
                        carpetArea: null,
                        buildUpArea: null,
                        terraceArea: null,
                        guidelineSqftPrice: null,
                        floors: 0,
                        totalBhk: 0,
                        floorsBhk: [{ floor: 1, bhk: 0 }],
                        bathrooms: 0,
                        roadFacingSide: "",
                        totalPrice: null,
                        furnished: "",
                        parking: "",
                        coveredParking: "",
                        lift: "",
                        swimmingPool: "",
                        villaViewType: "",
                        unitStatusId: "",
                      })
                    }
                    className="px-4 py-2 bg-customGreen text-white rounded-md transition-colors flex items-center mx-auto"
                  >
                    Add New Unit
                  </button>
                </td>
              </tr>
            )}
          </tfoot>
        </table>
      </div>
    </div>
  );
};

export default VillaUnitTable;
